import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=3aa52cf2&scoped=true"
import script from "./Judge.vue?vue&type=script&lang=js"
export * from "./Judge.vue?vue&type=script&lang=js"
import style0 from "./Judge.vue?vue&type=style&index=0&id=3aa52cf2&prod&lang=scss&scoped=true"
import style1 from "./Judge.vue?vue&type=style&index=1&id=3aa52cf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa52cf2",
  null
  
)

export default component.exports